import React from 'react';
import { Activity } from 'new/elements/Activity';
import { RESOURCE_TYPE_DATA_SET } from 'js/constants/resourceTypes';

interface ActivityTabProps {
  dataset: {
    id: number;
    [key: string]: any;
  };
}

export const ActivityTab = ({ dataset }: ActivityTabProps) => {
  return <Activity resourceId={dataset.id} resourceType={RESOURCE_TYPE_DATA_SET} data={dataset} />;
};
